module.exports = __webpack_public_path__ + "img/2.e5d9cb04.png";